import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { ContactHelper } from 'src/app/helpers/contact-helper';
import ProjectContact from 'src/app/model/company/projectContact';
import { Adjustment } from 'src/app/model/project/adjustment';
import { Repo } from 'src/app/model/project/repo';
import { SoldRented } from 'src/app/model/project/sold-rented';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';

@Component({
  selector: 'client-adjustment-form-shared',
  templateUrl: './client-adjustment-form-shared.component.html',
  styleUrls: ['./client-adjustment-form-shared.component.scss'],
  providers: [FormatPhoneNumber],
})
export class ClientAdjustmentFormSharedComponent implements OnInit {
  @Input()
  readOnly: boolean = false;

  @Input()
  projectHasIPBoards: boolean = false;

  @Input()
  showAppointmentWarning: boolean = false;

  @Input()
  adjustment: Adjustment | Repo | SoldRented;

  @Input()
  projectContacts: ProjectContact[];

  @Input()
  minDate: Date;

  @Output()
  save = new EventEmitter<any>();

  dateError: boolean = false;

  constructor(private formatPhoneNumber: FormatPhoneNumber) {}

  ngOnInit(): void {
    this.projectContacts.forEach((c) => {
      ContactHelper.setFormDisplays(c.contact, this.formatPhoneNumber);
    });

    if (this.adjustment.id == null && this.projectHasIPBoards) {
      this.adjustment.projectPlacement.appointmentWithCustomer = true;
    }
  }

  placeASAP(event) {
    this.adjustment.projectPlacement.placeASAP = event;
    if (event) {
      delete this.adjustment.projectPlacement.placementEarliestDate;
    }
    this.emitSave();
  }

  placementEarliestDateChange(event) {
    this.dateError = false;
    if (event != null) {
      this.adjustment.projectPlacement.placeASAP = false;
      if (
        this.adjustment.projectPlacement.placementEarliestDate <= this.minDate
      ) {
        this.dateError = true;
      } else {
        this.emitSave();
      }
    }
  }

  emitSave() {
    this.save.emit(this.adjustment);
  }

  daysFilter = (d: moment.Moment): boolean => {
    const day = d.isoWeekday();
    return d.isSameOrAfter(this.minDate) && day !== 6 && day !== 7;
  };
}
